/**
 * 探索分析页面
 */

export default {
  dbl_exploration_title: "探索分析",
  dbl_exploration_leave_info: "离开当前分析任务？",
  dbl_exploration_metric: "统计指标",
  dbl_exploration_filter: "全局筛选",
  dbl_exploration_dimension: "分类维度",
  dbl_exploration_add_metric: "添加统计指标",
  dbl_exploration_add_filter: "添加全局筛选",
  dbl_exploration_add_dimension: "添加分类维度",
  dbl_exploration_edit_metric_name: "修改指标名称",
  dbl_exploration_and_relation: "添加并且关系",
  dbl_exploration_and: "且",
  dbl_exploration_or: "或",
  dbl_exploration_field_name: "字段名：",
  dbl_exploration_data_table: "数据源表：",
  dbl_exploration_selected: "已选中不可再选",
  dbl_exploration_discrete: "离散值",
  dbl_exploration_custom_region: "自定义区间",
  dbl_exploration_region: "区间",
  dbl_exploration_custom_region_bubble1: "The value cannot be empty",
  dbl_exploration_custom_region_bubble2: "左侧数值不能大于右侧数值",
  dbl_exploration_tab_all: "所有维度",
  dbl_exploration_tab_frequent: "常用推荐",
  dbl_exploration_tab_package: "用户包",
  dbl_exploration_tab_favorite: "我的收藏",
  dbl_exploration_all: "全部",
  dbl_exploration_common: "公共",
  dbl_exploration_register: "注册",
  dbl_exploration_active: "活跃",
  dbl_exploration_pay: "付费",
  dbl_exploration_exist: "留存",
  dbl_exploration_gone: "流失",
  dbl_exploration_of: "的",
  dbl_exploration_by: "按",
  dbl_exploration_calculate_hint: "计算条件已经修改，请重新点击计算按钮完成分析",
  dbl_exploration_clear_message: '确定清空所有选项？',
  dbl_exploration_clear_des: '将丢失此前未保存的分析设置与数据逻辑。',
  dbl_exploration_save_success: "保存{name}成功",
  dbl_exploration_save_as_success: "另存为{name}成功",
  dbl_exploration_finish_calculate: "终止计算",
  dbl_exploration_not_empty_metric: "统计指标不能为空",
  dbl_exploration_calculate: "计算",
  dbl_exploration_calculate_by_dimension: "分维度进行计算",
  dbl_exploration_: "",

};